import type { Booking } from "../types/Booking";
import type { ProposalMessageData, Request } from "../types/Request";

function findFirstSentBooking(
    proposalMessages: ProposalMessageData[],
    booking: string,
): ProposalMessageData | undefined {
    return proposalMessages.filter((it) => it.bookings.includes(booking))[0];
}

function findLastSentBooking(
    proposalMessages: ProposalMessageData[],
    booking: string,
): ProposalMessageData | undefined {
    const messagesThatIncludeTheBooking = proposalMessages.filter((it) =>
        it.bookings.includes(booking),
    );
    return messagesThatIncludeTheBooking.length !== 0
        ? messagesThatIncludeTheBooking[messagesThatIncludeTheBooking.length - 1]
        : undefined;
}

export function findBookingFromProposal(
    request: Request,
    booking: string,
    sent: "first-send" | "last-send",
): ProposalMessageData | undefined {
    if (!request.proposal || request.proposal?.messages.length === 0) {
        return undefined;
    }

    switch (sent) {
        case "first-send":
            return findFirstSentBooking(request.proposal.messages, booking);
        case "last-send":
            return findLastSentBooking(request.proposal.messages, booking);
        default:
            return undefined;
    }
}

export function groupBookings(request: Request, bookings: Booking[]) {
    return {
        confirmed: bookings.filter(
            (booking) => booking.reservationStatus === "confirmed",
        ),
        sent: bookings.filter(
            (booking) =>
                booking.reservationStatus !== "confirmed" &&
                request.proposalBookings?.includes(booking.id),
        ),
        unsent: bookings.filter(
            (booking) =>
                booking.reservationStatus !== "confirmed" &&
                !request.proposalBookings?.includes(booking.id),
        ),
    };
}
